import { AppState } from '@/vuex/store';
import MassSendMsg, { MassSendWxNews } from '@/mass/models/MassSendMsg';
import CustomerRemark from '@/customer/models/CustomerRemark';

export default {
  UPDATE_MASS_SEND_MSG: (state: AppState, msg: MassSendMsg) => {
    state.massState.massSendMsg = msg;
  },
  UPDATE_MASS_SEND_WX_NEWS: (state: AppState, news: MassSendWxNews) => {
    state.massState.massSendMsg.WxNews = news;
  },
  UPDATE_REMARKS: (state: AppState, remarks: CustomerRemark[]) => {
    state.massState.remarks = remarks;
  },
};
